<template>
    <div class="sign-seal-component" :class="{invalid: isInvalidHighlight()}">
        <label class="poa-title" v-html="$t('f_allow_us_to_take_you_case')" />
        <div class="passable-input">
            <input
                v-model="isPassable" 
                v-validate="'truly'"
                type="text"
                name="poa">
        </div>

        <div :class="['inner-block', {'completed': status == 'Completed'}]">
            <div v-if="isNoEnvelope" class="info-message">
                {{ $t('f_click') }}
                <span class="here" @click="createEnvelope">{{ $t('f_here') }}</span>,
                {{ $t('f_to_generate_poa') }}
            </div>

            <div v-if="processing" class="spinner">
                <div class="rect1" />
                <div class="rect2" />
                <div class="rect3" />
                <div class="rect4" />
                <div class="rect5" />
            </div>

            <iframe
                v-if="isActualEnvelope"
                id="sign-created"
                ref="iframe"
                :src="owner_sign_link"
                class="sign-seal-frame"
                :class="{'modal_mode': modal_mode}" />
        </div>
    </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import formNavMixin from '../mixins/formNavMixin'
  import { mapFields } from 'vuex-map-fields'

  export default {
    mixins: [formNavMixin],
    inject: ['$validator'],
    props: ['name', 'scope'],
    data() {
      return {
        modal_mode: false,
      }
    },
    computed: {
      ...mapFields([
        'signseal.poa.processing',
        'signseal.poa.status',
        'signseal.poa.activated',
        'signseal.poa.isValid'
      ]),
      ...mapGetters({
        owner_sign_link: 'signseal/owner_sign_link',
        isNoEnvelope: 'signseal/isNoEnvelope',
        isActualEnvelope: 'signseal/isActualEnvelope'
      }),
      isPassable: function() {
        return !this.activated || (this.activated && this.isValid)
      }
    },
    created() {
      window.addEventListener("message", this.getIframeMessage)
    },
    destroyed() {
      window.removeEventListener("message", this.getIframeMessage)
    },
    methods: {
      createEnvelope: function() {
        this.$store.dispatch('signseal/postEnvelope', 'poa')
            .catch(error => {
                alert(error)
            })
      },
      showModal: function() {
        $('body').css({'overflow': 'hidden'})
        this.modal_mode = true
      },
      hideModal: function() {
        $('body').css({'overflow': 'auto'})
        this.modal_mode = false
      },
      submit: function() {
        this.$refs.iframe.contentWindow.postMessage(JSON.stringify({action: 'submit'}), '*')
      },
      getIframeMessage: function(event) {
        if (event.data) {
          let json = {}
          try { JSON.parse(event.data) } catch (error) { return }
          switch (json.action) {
            case "open-modal":
              this.showModal()
              break
            case "hide-modal":
              this.hideModal()
              break
            case "sign-success":
              this.$store.commit('signseal/updateField', {
                path: `${this.name}.status`,
                value: 'Completed'
              })
              break
            case "provide-poa-valid":
              this.activated = true
              this.isValid = json.value
          }
        }
      },
      isInvalidHighlight: function() {
        let field = (((this.fields[`$${this.scope}`] || {})[this.name]) || {})
        return field.invalid && field.validated
      },
    }
  }
</script>

<style lang="scss" scoped>
  @import '~@stylesheets/_vars.scss';

  .sign-seal-component {
    color: gray;
    margin-top: 15px;
  }
  .poa-title{
    color: $light_black_b;
    display: block;
    font-weight: 400;
  }
  .passable-input input{
    visibility: hidden;
  }
  .invalid .inner-block{
    border-color: $red;
  }
  .inner-block {
    height: 340px;
    html.mobile & {
      height: 430px;
    }
    background-color: #f5f5f5;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid white;
  }
  .info-message{
    padding: 0 20px;
  }
  .spinner {
    margin: 0;
  }
  .sign-seal-frame {
    border: none;
    height: 100%;
    width: 100%;
  }
  @media (max-width: 992px) {
    .sign-seal-frame {
      width: 100% !important;
    }
  }
  .sign-seal-frame.modal_mode {
    position: fixed;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    z-index: 1000;
  }
  .here {
    cursor: pointer;
    color: $orange_b;
    &:hover {
      text-decoration: underline;
    }
  }
</style>
